import has, { add, exists } from '@dojo/framework/core/has';
import { AbstractCategoryLogger, LogLevel } from 'typescript-logging';
import { Queue } from 'collections';
import { dateToJSON } from 'dates';
import * as URI from 'uri-js';
import * as platform from 'platform';
const SECONDS = 1000;
const QUEUE_SIZE = 37;
async function postTrakData(url = ``, data = []) {
    const response = await fetch(url, {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        },
        redirect: 'follow',
        referrer: 'client',
        body: JSON.stringify(data)
    });
    return response.ok;
}
const messages = new Queue();
const trakurl = URI.resolve(window.hcstatic.portal_url, '/lcctrak');
export async function send_messages() {
    if (!messages.isEmpty()) {
        const msgs = [];
        while (messages.peek() !== undefined) {
            msgs.push(messages.dequeue());
        }
        const sent = await postTrakData(trakurl, msgs);
        if (!sent) {
            msgs.reverse().forEach((msg) => {
                messages.pushfront(msg);
            });
        }
        return sent;
    }
    return true;
}
export class LccTrakLogger extends AbstractCategoryLogger {
    browser;
    os;
    _sched = null;
    _queueLimit;
    constructor(category, runtimeSettings) {
        super(category, runtimeSettings);
        this.os = (platform.os ? platform.os.toString() : '').slice(0, 20);
        const name = platform.name ? platform.name : platform.ua;
        const version = platform.version ? ` ${platform.version}` : '';
        const manufacturer = platform.manufacturer ? `${platform.manufacturer} ` : '';
        const product = platform.product ? ` (${manufacturer}${platform.product})` : '';
        this.browser = `${name}${version}${product}`.slice(0, 20);
        const _ua = navigator.userAgent;
        if (/Mac/.test(_ua) && /OS X/.test(this.os) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
            this.os = `ipadOS as ${this.os}`.slice(0, 20);
        }
        if (/[Ee]dg/.test(_ua) && /Chrome/.test(this.browser)) {
            const vermatch = /[Ee]dg\/([0-9.]+)/.exec(_ua);
            const ver = vermatch !== null ? vermatch[1] : '';
            this.browser = `Edge ${ver}`.slice(0, 20);
        }
        const osStr = this.os.toLowerCase();
        if (!exists('ios')) {
            add('ios', /ios|ipados/.test(osStr));
        }
        if (!exists('android')) {
            add('android', /android/.test(osStr));
        }
        this._queueLimit = QUEUE_SIZE;
    }
    schedule() {
        const setLimit = (success) => {
            if (success) {
                this._queueLimit = QUEUE_SIZE;
            }
            else {
                while (messages.count() > 300) {
                    messages.dequeue();
                }
                this._queueLimit = messages.count() + 7;
            }
            return success;
        };
        if (this._sched === null) {
            this._sched = setTimeout(async () => {
                const success = await send_messages();
                setLimit(success);
                this._sched = null;
            }, 60 * SECONDS);
        }
        else if (messages.count() > this._queueLimit) {
            clearTimeout(this._sched);
            this._sched = null;
            send_messages().then(setLimit);
        }
    }
    _cook_message(msg) {
        let actualStringMsg = '';
        let dataString = '';
        const messageOrLogData = msg.message;
        if (typeof messageOrLogData === 'string') {
            actualStringMsg = messageOrLogData;
        }
        else {
            const logData = messageOrLogData;
            actualStringMsg = logData.msg;
            if (logData.data) {
                dataString = logData.ds ? logData.ds(logData.data) : `[data]: ${JSON.stringify(logData.data)}`;
            }
        }
        let message = `${actualStringMsg}${dataString}`;
        if (msg.errorAsStack !== null) {
            message = `${message}\n${msg.errorAsStack}`;
        }
        return message;
    }
    doLog(msg) {
        const { portal_userid: userid = '', portal_site: site = '', portal_language: language = 'en', sessionid = '' } = window.hcstatic;
        const { browser, os } = this;
        const level = LogLevel[msg.level].toUpperCase();
        const category = msg.categories.map((cat) => (cat.name === 'console' ? 'system' : cat.name)).join(',');
        const isConsole = msg.categories.filter((cat) => cat.name === 'console').length > 0;
        const trakmsg = {
            browser,
            category,
            language,
            level,
            logger: 'webapp3',
            logstamp: dateToJSON(msg.date),
            message: this._cook_message(msg),
            os,
            retries: 0,
            status: level === 'ERROR' ? 500 : level === 'WARN' ? 400 : 200,
            sessionid,
            site,
            userid
        };
        messages.enqueue(trakmsg);
        this.schedule();
        if (has('dev-build') && !isConsole) {
            const fullMsg = this.createDefaultLogMessage(msg);
            console.log(fullMsg);
        }
    }
}
